export default "__VITE_ASSET__0ojcfue9__"